import React, { Fragment, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { openShift } from "@redux"
import { addShift } from "services"
import { Button, CurrencyInput, KeyPads } from "components"
import ScsShiftIsAlreadyOpenModal from "./ScsShiftIsAlreadyOpenModal"
import classes from "./index.module.scss"

const ShiftCashierStart = (props) => {
  const { setContent } = props

  const [t, i18n] = useTranslation()

  const history = useHistory()

  const dispatch = useDispatch()

  const cashierBranchId =
    useSelector(state => state.userAccountInfo.branchId)

  const [sending, setSending] = useState(false)
  const [startCash, setStartCash] = useState(0)
  const [alreadyOpenShiftId, setAlreadyOpenShiftId] = useState("")
  const [openShiftIsAlreadyOpenModal, setOpenShiftIsAlreadyOpenModal] = useState(false)

  const handleStartShift = async () => {
    setSending(true)

    try {
      const response =
        await addShift({
          branchId: cashierBranchId,
          startingCash: startCash,
        })

      if (!!response.error) {
        setSending(false)

        setAlreadyOpenShiftId(response.shiftId)

        setOpenShiftIsAlreadyOpenModal(true)

        return
      }

      dispatch(
        openShift(startCash, response._id)
      )

      history.push("/foods")
    } catch (err) {
      console.log(err)

      toast.error(t("عملیات_انجام_نشد"))

      setSending(false)
    }
  }

  const handleGoBack = () => {
    setContent("cashierBranches")
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["container"]}>
        <div className={classes["wrapper"]}>
          <CurrencyInput
            label={t("مقدار_پول_نقد_اولیه_تومان")}
            value={startCash}
            readOnly
            onChange={() => { }}
          />

          <div className={classes["footer"]}>
            <Button
              loading={sending}
              color="success"
              onClick={handleStartShift}
            >
              {t("شروع_شیفت")}
            </Button>

            <Button
              disabled={sending}
              color="danger"
              onClick={handleGoBack}
              className={clsx(
                classes["button"],
                isLtr && classes["button-ltr"]
              )}
            >
              {t("انتخاب_شعبه")}
            </Button>
          </div>
        </div>

        <div className={classes["keypad"]}>
          <KeyPads
            value={startCash}
            onChange={value => setStartCash(value)}
          />
        </div>
      </div>

      <ScsShiftIsAlreadyOpenModal
        startCash={startCash}
        alreadyOpenShiftId={alreadyOpenShiftId}
        openShiftIsAlreadyOpenModal={openShiftIsAlreadyOpenModal}
        setOpenShiftIsAlreadyOpenModal={setOpenShiftIsAlreadyOpenModal}
      />
    </Fragment>
  )
}

export default ShiftCashierStart